export default __webpack_public_path__ + "static/natural3-44d198f6f5821ff26d2cb534286678c5.jpg";